import { ChannelTypeUsedInView } from '~/components/CustomTag/@types';
import { MarqCommonEnumsChannelTypeEnum } from '~/swagger/data-contracts';
/**
 * marketplace -> ecommerce
 * social_media -> social_media
 * 위의 케이스에서만 사용!
 */
export const parseChannelTypeUsedInViewToAPIChannelType = (
  type: ChannelTypeUsedInView
): MarqCommonEnumsChannelTypeEnum => {
  if (type === 'marketplace') {
    return MarqCommonEnumsChannelTypeEnum.Ecommerce;
  } else if (type === 'social_media') {
    return MarqCommonEnumsChannelTypeEnum.SocialMedia;
  } else if (type === 'website_content') {
    return MarqCommonEnumsChannelTypeEnum.WebsiteContents;
  } else {
    return MarqCommonEnumsChannelTypeEnum.DomainNames;
  }
};
